export class Controller{
    constructor(){

    }
    $onInit(){

    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/google-hangouts-bot/google-hangouts-bot.controller.js